<script>
// import {
//   PostApiWithAuthorizationAction
// } from "@/helpers/apiActions";
import {  common } from '@/mixins/common';
import { GetApiActionWithAuthorization, PostApiWithAuthorizationAction } from '../../../helpers/apiActions';
import FormOwnerManage from '../../drawers/setting/FormOwnerManage.vue';

export default {
  name: 'SettingApplicationPage',
  components: {FormOwnerManage},
  props: {},
  data() {
    return {
        tableData: [],
        fields: [
            {
                key: "Name",
                value: 'Name',
                sortable: false,
            },
            {
                key: "api_test",
                value: 'API Test',
                sortable: false,
            },
            {
                key: "action",
                value: 'Action',
                sortable: false,
                center: true
            }
        ],
        selectedOwner: {
            id: 0
        },
        displayOwnerFormDrawer: false
    }
  },
  mixins: [
    common
  ],
  methods: {
    loadPageData() {
        let _vm = this
        return GetApiActionWithAuthorization("admin/setting/application/get-page-data").then(res => {
            _vm.tableData = res.data
        });
    },
    generateToken(id) {
        if (confirm('Token Generation requires that you are connected to the right Ebay Account!!!')) {
            return GetApiActionWithAuthorization("admin/setting/application/generate-token/" + id).then(res => {
                alert(res.authUrl)
            });
        }
    },
    refreshToken(id) {
        if (confirm('Are you sure that you want renew the token ?')) {
            const _vm = this
            return GetApiActionWithAuthorization("admin/setting/application/renew-token/" + id).then(res => {
                if (res.status === "success") {
                    _vm.$toast.success(res.message, {
                        position: "top-right",
                        timeout: 1000,
                        closeOnClick: true,
                    });
                } else {
                    _vm.$toast.error(res.message, {
                        position: "top-right",
                        timeout: 1000,
                        closeOnClick: true,
                    });
                }
            });
        }
    },
    checkApiV1(id) {
        const _vm = this
        return GetApiActionWithAuthorization("admin/setting/application/check-api/" + id + "/v1").then(() => {
            _vm.loadPageData()
        });
    },
    checkApiV2(id) {
        const _vm = this
        return GetApiActionWithAuthorization("admin/setting/application/check-api/" + id + "/v2").then(() => {
            _vm.loadPageData()
        });
    },
    addData() {
        let _vm = this
        _vm.selectedOwner = {
            id: 0,
            firstName: '',
            lastName: '',
            email: '',
            companyName: '',
            phone: ''
        }
        _vm.displayOwnerFormDrawer = true
    },
    editData(user) {
        let _vm = this
        _vm.selectedOwner = user
        _vm.displayOwnerFormDrawer = true
    },
    deleteData(userId) {
        if (confirm('Are you sure that you want delete this owner ?')) {
            let _vm = this
            PostApiWithAuthorizationAction("admin/setting/owner/delete-user/" + userId).then(() => {
                _vm.tableData = _vm.tableData.filter(v=>v.id!=userId)
            });
        }
    }
  },
  computed: {},
  mounted () {
    let _vm = this
    _vm.loadPageData()
    //
    _vm.$root.$on('reload-owner-manage-drawer', () => {
        _vm.loadPageData()
        _vm.displayOwnerFormDrawer = false
    })
  }
}
</script>
<template>
    <div class="setting-general__content">
        <el-drawer
            ref="ownerDrawer"
            :title="selectedOwner.id == 0 ? 'Add New Owner' : 'Update Owner'"
            :visible.sync="displayOwnerFormDrawer"
            :close-on-press-escape="false"
            :with-header="true"
            :wrapperClosable="false"  
            :append-to-body="true"
            custom-class="common-drawer">
            <form-owner-manage :data="selectedOwner"/>
        </el-drawer>
        <!--div class="mb-1 text-right">
            <b-button
                variant="primary"
                @click="addData()"
            >
            <i class="fas fa-plus-circle"></i> New Owner
            </b-button>
        </div-->
        <b-row>
            <b-col cols="6">
            <table
                  role="table"
                  aria-busy="false"
                  aria-colcount="10"
                  class="table b-table"
                  style="background-color: rgba(0, 0, 0, 0.05); border: 5px solid #5b5f70"
                >
                  <thead
                    role="rowgroup"
                    class=""
                    style="background-color: #74788d; color: white"
                  >
                    <tr role="row" class="">
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex="1"
                        :class="[
                          field.center ? 'text-center': '',
                          'px-4'
                        ]"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <div>{{ field.value }}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr
                      role="row"
                      aria-rowindex="1"
                      class=""
                      v-for="data in tableData"
                      :key="data.id"
                    >
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px">
                            {{ data.name }}
                        </td>
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px">
                            <div v-if="data.type === 'ebay'">
                                <div class="mb-1">
                                    <b-button
                                        type="submit"
                                        variant="success"
                                        class="btn-sm"
                                        @click="checkApiV1(data.id)">
                                        <i class="bx bx-wrench"></i> V1 Check
                                    </b-button> &nbsp;<i class="fas fa-check-circle" v-if="data.apiV1Status == 1"></i>
                                </div>
                                <div class="">
                                    <b-button
                                        type="submit"
                                        variant="success"
                                        class="btn-sm"
                                        @click="checkApiV2(data.id)">
                                        <i class="bx bx-wrench"></i> V2 Check
                                    </b-button> &nbsp;<i class="fas fa-check-circle" v-if="data.apiV2Status == 1"></i>
                                </div>
                            </div>
                            <div v-else></div>
                        </td>
                        <td
                            aria-colindex="2"
                            role="cell"
                            :class="['text-right', 'px-1']">
                            <div class="">
                                <b-button
                                    type="button"
                                    variant="warning"
                                    v-if="data.type === 'ebay'"
                                    @click="refreshToken(data.id)">
                                    Refresh Token
                                </b-button>&nbsp;&nbsp;
                                <b-button
                                    type="button"
                                    variant="primary"
                                    v-if="data.type === 'ebay'"
                                    @click="generateToken(data.id)">
                                    Generate Token
                                </b-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-col>
    </b-row>
    </div>
</template>
<style scoped>
td {
    vertical-align: middle;
}
</style>